module.exports = __webpack_public_path__ + "img/board_layout_6.20e3aff9.png";